"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createId = void 0;
const nanoid_1 = require("nanoid");
const ALPHABET_UPPER = "ABCDEDFGHIJKLMNOPQRSTUVWXYZ";
const ALPHABET_LOWER = ALPHABET_UPPER.toLowerCase();
const ALPHABET = ALPHABET_UPPER + ALPHABET_LOWER + "0123456789";
exports.createId = (0, nanoid_1.customAlphabet)(ALPHABET, 12);
//# sourceMappingURL=id.js.map